import { render, staticRenderFns } from "./Expense.edit.vue?vue&type=template&id=58b89eba&scoped=true&"
import script from "./Expense.edit.vue?vue&type=script&lang=js&"
export * from "./Expense.edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b89eba",
  null
  
)

export default component.exports